import { ApplicationMenuContext as e } from "./ApplicationMenuContext.js";
import { c as t } from "react/compiler-runtime";
import { useContext as n, useEffect as r } from "react";
//#region src/components/ApplicationMenu/useRegisterMenuItem.ts
function i(i, o) {
	let s = t(5), c = n(e), l, u;
	s[0] !== o || s[1] !== i || s[2] !== c ? (l = () => {
		if (!c || !o) return;
		let e = (Array.isArray(o) ? o : [o]).map((e) => c.register(i, e));
		return () => e.forEach(a);
	}, u = [
		c,
		i,
		o
	], s[0] = o, s[1] = i, s[2] = c, s[3] = l, s[4] = u) : (l = s[3], u = s[4]), r(l, u);
}
function a(e) {
	return e();
}
//#endregion
export { i as useRegisterMenuItem };
